"use strict";
/**
 * --------------------------------------------------------------------------
 * DiceBear Female (@dicebear/avatars-female-sprites)
 *
 * Code licensed under MIT (https://github.com/dicebear/dicebear/blob/v4/packages/avatars-female-sprites/LICENSE)
 * Copyright (c) 2012 Plastic Jam
 * Copyright (c) 2021 Florian Körner
 * --------------------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.schema = exports.meta = exports.create = void 0;
const avatars_1 = require("@dicebear/avatars");
const core_1 = require("./core");
let { create, meta, schema } = core_1.style;
exports.create = create;
exports.meta = meta;
exports.schema = schema;
/** @deprecated will be removed in Version 5.0 */
exports.default = avatars_1.utils.style.createLegacyWrapper(core_1.style);
